export type CandidateSearchResultType = 'EXACT_MATCH' | 'SEMANTIC';

const VALID_RESULT_TYPES: CandidateSearchResultType[] = ['EXACT_MATCH', 'SEMANTIC'];

export class CandidateSearchParams {
  auraIds?: string[];
  deep?: boolean;
  experienceMax?: number;
  experienceMin?: number;
  industries?: string[];
  limit?: number;
  location?: string;
  page?: number;
  query?: string;
  resultType?: CandidateSearchResultType;
  skills?: string[];

  constructor(init?: Partial<CandidateSearchParams>) {
    if (!init) return;
    Object.assign(this, init);
    const raw = init.resultType;
    if (raw !== undefined) {
      this.resultType =
        typeof raw === 'string' && VALID_RESULT_TYPES.includes(raw as CandidateSearchResultType)
          ? (raw as CandidateSearchResultType)
          : undefined;
    }
  }
}

export class ListSavedCandidatesParams {
  limit?: number;
  page?: number;
  search?: string;

  constructor(init?: Partial<ListSavedCandidatesParams>) {
    if (!init) return;
    Object.assign(this, init);
  }
}

export class SaveCandidateParams {
  candidateProfileId: string;
  note?: string;
  tags?: string[];

  constructor(init: SaveCandidateParams) {
    this.candidateProfileId = init.candidateProfileId;
    this.note = init.note;
    this.tags = init.tags;
  }
}

export class UpdateSavedCandidateParams {
  note?: string;
  savedCandidateId: string;
  tags?: string[];

  constructor(init: UpdateSavedCandidateParams) {
    this.savedCandidateId = init.savedCandidateId;
    this.note = init.note;
    this.tags = init.tags;
  }
}
